import { jsx as _jsx } from "react/jsx-runtime";
import { useMember } from '@tribeplatform/react-sdk/hooks';
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar';
export const MemberAvatar = ({ id }) => {
    var _a, _b, _c;
    const { data: member, isLoading } = useMember({
        variables: { id },
        fields: { profilePicture: 'all' },
    });
    if (isLoading) {
        return (_jsx("div", { role: "status", className: "max-w-sm animate-pulse", children: _jsx("div", { className: "rounded-full bg-skeleton h-10 w-10" }, void 0) }, void 0));
    }
    if (!member && !isLoading) {
        return null;
    }
    const profilePicture = ((_b = (_a = member === null || member === void 0 ? void 0 : member.profilePicture) === null || _a === void 0 ? void 0 : _a.urls) === null || _b === void 0 ? void 0 : _b.thumb) ||
        ((_c = member === null || member === void 0 ? void 0 : member.profilePicture) === null || _c === void 0 ? void 0 : _c.url);
    return _jsx(Avatar, { name: member.name, src: profilePicture }, member.id);
};
//# sourceMappingURL=MemberAvatar.js.map